import { useCallback } from 'react';
import { Element, FieldElement, CombinationResult } from '../types';

interface CombinationCheckHookResult {
  checkCombination: (
    element1: FieldElement, 
    element2: FieldElement
  ) => Promise<{
    success: boolean;
    centerPosition?: { x: number; y: number };
    result?: CombinationResult;
    element1Id?: string;
    element2Id?: string;
  }>;
}

/**
 * Хук для проверки комбинаций элементов
 */
export function useCombinationCheck(
  onCombine: (element1: Element, element2: Element) => Promise<CombinationResult | null>
): CombinationCheckHookResult {
  
  /**
   * Проверяет комбинацию двух элементов
   */
  const checkCombination = useCallback(async (
    element1: FieldElement, 
    element2: FieldElement
  ) => {
    console.log(`Проверка комбинации между элементами: ${element1.name} и ${element2.name}`);
    
    // Проверяем расстояние между элементами
    const distance = Math.sqrt(
      Math.pow(element1.position.x - element2.position.x, 2) +
      Math.pow(element1.position.y - element2.position.y, 2)
    );
    
    console.log(`Расстояние между элементами: ${distance}`);
    
    // Если элементы слишком далеко друг от друга
    if (distance >= 100) {
      console.log('Элементы слишком далеко друг от друга');
      return { success: false };
    }
    
    console.log('Элементы достаточно близко, проверяем комбинацию');
    const result = await onCombine(element1, element2);
    
    if (!result) {
      console.log('Комбинация не найдена или была отменена пользователем');
      return { success: false };
    }
    
    console.log(`Комбинация успешна, результат: ${result.newElement.name}`);
    
    // Вычисляем центральную позицию между элементами
    const centerPosition = {
      x: (element1.position.x + element2.position.x) / 2,
      y: (element1.position.y + element2.position.y) / 2
    };
    
    return {
      success: true,
      result,
      centerPosition,
      element1Id: element1.fieldId,
      element2Id: element2.fieldId
    };
  }, [onCombine]);

  return { checkCombination };
} 